.titleContainer {
  align-items: baseline;
  display: flex;
  gap: var(--via-space-200);
}

.rowContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--via-space-800);
}

.accordionTitle.accordionTitle {
  font-size: 18px;
  margin: var(--via-space-200) 0;
}

.banner.banner {
  margin-bottom: var(--via-space-400);
}
